import React from 'react';
import './Outro.css';

function Outro() {
  return (
    <section className="outro-section">
      <h2>Leasing for the best price should not be hard!</h2>
      <p>Let us help you obtain the best price</p>
    </section>
  );
}

export default Outro;